/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type GovernanceProjectsAdminQuery,
} from './__generated__/GovernanceProjectsAdminQuery.graphql.ts';

type Queries = { governanceProjectsAdmin: GovernanceProjectsAdminQuery };
type ExtraProps = { isAdmin: boolean };

type GovernanceProjectsAdminEntryPointComponent = EntryPointComponent<Queries, {}, {}, ExtraProps>;

export const governanceProjectsAdminEntryPoint: EntryPoint<
	GovernanceProjectsAdminEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<GovernanceProjectsAdminEntryPointComponent>(
		/* webpackChunkName: "async-governance-projects" */ './GovernanceProjectsAdmin.tsx',
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => {
		const { isAdmin } = tenantContext;

		if (!isAdmin) {
			return {
				extraProps: { isAdmin },
			};
		}

		return {
			queries: {
				governanceProjectsAdmin: {
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
					parameters,
					variables: {
						cloudId: tenantContext.cloudId,
					},
				},
			},
			extraProps: { isAdmin },
		};
	},
});
